var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReturn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "11px",
    viewBox: "0 0 12 11",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Path")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Admin---Web-Jobs-Details-View",
    transform: "translate(-1388.000000, -162.000000)",
    fill: "#335498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "return-button",
    transform: "translate(1388.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21440808,1.7926216 L4.09152692,1.7926216 L4.52080193,0.74764662 C4.61211512,0.524660022 4.54532212,0.269685639 4.35673732,0.119025618 C4.16790732,-0.0315367299 3.902182,-0.0398877392 3.70354392,0.0975620595 L0.234745885,2.49691446 C0.0827942534,2.6020102 -0.00542939826,2.77667327 0.000259286338,2.96073733 C0.00592345074,3.1446793 0.104739825,3.31348201 0.262870545,3.40903025 L3.89001998,5.60234225 C4.09640644,5.72707019 4.36031727,5.70228577 4.53933919,5.54132128 C4.71863084,5.38038122 4.77049104,5.11859417 4.66731007,4.90151677 L4.19056398,3.89714918 L9.21440808,3.89714918 C9.58512887,3.89714918 9.88670271,4.20325518 9.88670271,4.57240886 L9.88670271,8.23151834 C9.88670271,8.60067202 9.58512887,8.89544799 9.21440808,8.89544799 L3.6546997,8.89544799 C3.15875429,8.89544799 2.7566967,9.29580807 2.7566967,9.78968969 L2.7566967,10.1057095 C2.7566967,10.5996399 3.15875429,11 3.6546997,11 L9.21440808,11 C10.750402,11 12,9.76121812 12,8.23149392 L12,4.57243328 C12,3.04270908 10.750402,1.7926216 9.21440808,1.7926216 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReturn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Return.c9d78227.svg";
export { ForwardRef as ReactComponent };